import { getAllowedOrigins } from 'magpie-lib/config';
export const isHubspotOrigin = origin => {
  const allowedOrigins = getAllowedOrigins();
  return allowedOrigins.includes(origin);
};